export default {
  checkCharts: {
    width: "l",
    component: () =>
      import(
        /* webpackChunkName: "setting_dialog" */ "@/mods/statistic/roomStoreStatistic/dialog/CheckCharts"
      ),
  },
};
